var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2368 19.1277H24.5263M24.5263 22.9574H14.2368M14.2368 26.7872H24.5263M13.6316 11.4681H11.2105C10.542 11.4681 10 12.0277 10 12.7181V35.75C10 36.4404 10.542 37 11.2105 37H27.5526C28.2212 37 28.7632 36.4404 28.7632 35.75V33.1702M13.6316 11.4681H27.5526C28.2212 11.4681 28.7632 12.0277 28.7632 12.7181V33.1702M13.6316 11.4681V8.25C13.6316 7.55964 14.1736 7 14.8421 7H31.7895C32.458 7 33 7.55964 33 8.25V31.9202C33 32.6106 32.458 33.1702 31.7895 33.1702H28.7632",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.c39f59943bc39ba2591136e9a9abe5f5.svg";
export { ForwardRef as ReactComponent };